import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const SelectedZoneSchema_ = z.object({
  profileId: z.string(),
  locationGroupId: z.string(),
  zoneName: z.string(),
});
export const SelectedZoneSchema: z.ZodType<SelectedZoneSchema> =
  SelectedZoneSchema_;
export interface SelectedZoneSchema extends z.infer<
  typeof SelectedZoneSchema_
> {}

export const triggerAutoOnboardCheckoutOptimization = {
  name: "triggerAutoOnboardCheckoutOptimization" as const,
  input: z.object({
    teamId: zExt.objectId(),
    selectedZones: z.array(SelectedZoneSchema).optional(),
    setProductMetafields: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
